
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M17.2583 4.69167C17.5833 5.01667 17.5833 5.54167 17.2583 5.86667L15.7333 7.39167L12.6083 4.26667L14.1333 2.74167C14.4583 2.41667 14.9833 2.41667 15.3083 2.74167L17.2583 4.69167ZM2.5 17.0833V14.55C2.5 14.4333 2.54167 14.3333 2.625 14.25L11.7167 5.15834L14.8417 8.28334L5.74167 17.375C5.66667 17.4583 5.55833 17.5 5.45 17.5H2.91667C2.68333 17.5 2.5 17.3167 2.5 17.0833Z" fill="#93A0AE"/>'
  }
})
